/**
 * Client-side platform Super Admin detection.
 * Super Admin = global operator (role_id 1 with no pump); pump-scoped users must not pass
 * even if role_id is 1. Prefer API flag is_platform_super_admin when present.
 */

export function isPlatformSuperAdmin(profile) {
  if (!profile) {
    return false;
  }

  if (typeof profile.is_platform_super_admin === 'boolean') {
    return profile.is_platform_super_admin;
  }

  const roleId = Number(profile.role_id);
  const pumpId = profile.pump_id;

  return (
    roleId === 1
    && (pumpId === null || pumpId === undefined || pumpId === '' || Number(pumpId) === 0)
  );
}

/**
 * @param {string} apiUrl
 * @param {string|null} token
 * @returns {Promise<object|null>}
 */
export async function fetchPlatformSuperAdminProfile(apiUrl, token) {
  if (!token) {
    return null;
  }

  const response = await fetch(`${apiUrl}/check_meta_date`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      Accept: 'application/json',
    },
    body: JSON.stringify({ pathurl: window.location.pathname }),
  });

  if (!response.ok) {
    return null;
  }

  const profile = await response.json();
  return isPlatformSuperAdmin(profile) ? profile : null;
}
